import { generateId } from '@freelancer/datastore/testing/helpers';
import type { SupportSuggestedArticle } from './support-suggested-articles.model';

export interface GenerateSupportSuggestedArticleOptions {
  readonly id?: number;
  readonly title?: string;
  readonly seoUrl?: string;
  readonly canonicalUrl?: string;
  readonly categoryName?: string;
  readonly userType?: string;
}

export function generateSupportSuggestedArticleObject({
  id = generateId(),
  title,
  seoUrl,
  canonicalUrl,
  categoryName = 'General',
  userType = 'freelancer',
}: GenerateSupportSuggestedArticleOptions): SupportSuggestedArticle {
  return {
    id,
    title: title ?? `Article ${id}`,
    seoUrl: seoUrl ?? `article-${id}`,
    canonicalUrl:
      canonicalUrl ?? `/support/${userType}/${categoryName}/${seoUrl}`,
    categoryName,
    userType,
  };
}

export function generateSupportSuggestedArticleObjects(
  articles: readonly GenerateSupportSuggestedArticleOptions[],
): readonly SupportSuggestedArticle[] {
  return articles.map(article =>
    generateSupportSuggestedArticleObject(article),
  );
}
